/**
 * https://app.asana.com/0/60697097430687/1206192044150275/f
 * 只有国际站点才会有GDPR的相关内容，只有用户同意了我们的 cookie policy 才需要加载的资源，目前主要是两类，一类是 googletagmanager，一类是 zoominfo
 * @returns
 */

import getUserInfo from 'globalCommon/services/getUserInfo';
import { getCdnDomain } from './utils';

function loadZoomInfo() {
    const zi = document.createElement('script');
    zi.type = 'text/javascript';
    zi.async = true;
    zi.referrerPolicy = 'unsafe-url';
    zi.src = 'https://ws.zoominfo.com/pixel/611ab1c6585f43001a88d021';
    document.body.appendChild(zi);
}

function loadBoot(system) {
    const cdnDomain = getCdnDomain(system);
    const bot = document.createElement('script');
    bot.type = 'text/javascript';
    bot.src = `https://${cdnDomain}/statics/js/0701/boot.js`;

    document.body.appendChild(bot);
}

function initGTM(system) {
    const gaTag = {
        'en': 'GTM-NRT9S655',
        'tw': 'GTM-M4SKTT44',
        'jp': 'GTM-5SWHP8PF',
        'em': 'GTM-5C2H8T3M',
    };
    const tagId = gaTag[system];
    const zi = document.createElement('script');
    zi.type = 'text/javascript';
    zi.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${tagId}');`;
    document.head.insertBefore(zi, document.head.firstChild);

    const ns = document.createElement('noscript');
    ns.type = 'text/javascript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${tagId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    ns.appendChild(iframe);
    document.body.insertBefore(ns, document.body.firstChild);
}

function getBesChannelsUserFlag() {
    const { wx_id: UnionID, open_id: OpenID, phone: PhoneNumber, email: Email } = getUserInfo() || {};
    const userFlag = { UnionID, OpenID, PhoneNumber, Email };
    return Object.keys(userFlag).reduce((acc, cur) => (userFlag[cur] ? { ...acc, [cur]: userFlag[cur] } : acc), {});
}

function reportDes() {
    fetch('/uapi/v1/des/report', { method: 'POST' }).catch((error) => {
        console.log('[BesChannelsAdapter:reportDes] ', error);
    });
}

export function registerBesChannels() {
    const script = document.createElement('script');
    const userFlag = getBesChannelsUserFlag();

    script.src = 'https://cdn.beschannels.com/js-sdk/collect-0.0.5.min.js';
    script.type = 'text/javascript;';
    script.async = true;
    script.referrerPolicy = 'unsafe-url';

    script.onload = () => {
        // SDK加载完成后初始化致趣收集器
        window.myCollect = new window.Collect({
            org_id: 'org9c62775d12ec259ade7473e6b65f951c',
            event_props: { source: 'web' },
            userFlag,
        });
        window.myCollect.init({
            page_view_auto: true,
            element_click_auto: false,
            events: ['BUTTON', 'input[type="submit"]', 'IMG', 'A'],
        });
        // 如果用户有 UnionID 或 OpenID，需要将用户信息放到单独的外部数据源对象下
        if (userFlag.UnionID || userFlag.OpenID) {
            reportDes();
        }
    };
    document.head.appendChild(script);
}

export function loadResource() {
    const curSystem = window.pageData.config.system.toLowerCase();

    if (curSystem === 'jp') {
        const _pd = window.pageData || {};
        const _d = _pd.data || {};
        const _ui = _pd.userInfo || _pd.user_info || _pd.teacherInfo || _pd.teacher_info ||
            _d.userInfo || _d.user_info || _d.teacherInfo || _d.teacher_info || {};
        const umu_id = _ui.umu_id;
        if (umu_id) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ user_id: String(umu_id) });
        }
    }

    if (curSystem === 'en') {
        loadZoomInfo();
    }
    if (['en', 'em', 'tw', 'jp'].includes(curSystem)) {
        loadBoot(curSystem);
        initGTM(curSystem);
    }
}
